import {
  filter, findIndex, get, merge, some, cloneDeep,
} from 'lodash';

export default () => ({
  methods: {
    isTargetSeries(fund) {
      const fundsSeries = get(fund, 'fundSeries.seriesFunds', null);
      return !!fundsSeries && Array.isArray(fundsSeries);
    },
    formatId(data) {
      const fundSeries = get(data, 'fundSeries');
      let { id } = data;
      if (fundSeries && this.isOneClientView) {
        id = `${id}-${fundSeries.id}`;
      }
      return id;
    },
    formatIsPending(data) {
      // TODO: this property will be implemented in the API later and
      // this FE implementation must change
      const fundSeries = get(data, 'fundSeries.seriesFunds');
      let { isPending } = data;
      if (!isPending) {
        isPending = some(fundSeries, { isPending: true });
      }
      return isPending;
    },
    formatOpenToNewSales(data) {
      const fundSeries = get(data, 'fundSeries.seriesFunds');
      let { isOpenToNewSales } = data;
      if (!isOpenToNewSales) {
        isOpenToNewSales = some(fundSeries, { isOpenToNewSales: true });
      }
      return isOpenToNewSales;
    },
    formatPendingStatuses(data) {
      let pendingStatuses = data.pendingStatus;
      if (this.isOneClientView && this.isTargetSeries(data)) {
        const fundSeries = get(data, 'fundSeries.seriesFunds');
        pendingStatuses = [];
        // This process is necessary because all the pending status come inside an array.
        // Then we have an array of fund pending statuses per fund series &
        // I need an array of status.
        fundSeries
          .filter((fund) => fund.pendingStatus !== null)
          .map(
            (fund) => Array.isArray(fund.pendingStatus)
              && fund.pendingStatus.map((status) => pendingStatuses.push(status)),
          ) || [];
      }
      return pendingStatuses;
    },
    formatFundStatuses(data) {
      let fundStatuses = data.fundStatus;
      if (this.isOneClientView && this.isTargetSeries(data)) {
        const fundSeries = get(data, 'fundSeries.seriesFunds');
        fundStatuses = [];
        // This process is necessary because all the fund status come inside an array.
        // Then we have an array of fund statuses per fund series & I need an array of status.
        fundSeries
          .filter((fund) => fund.fundStatus !== null || fund.pendingStatus !== null)
          .map((fund) => {
            if (Array.isArray(fund.pendingStatus)) {
              // Pending statuses have priority
              return fund.pendingStatus.map((status) => fundStatuses.push(status));
            }
            return fund.fundStatus.map((status) => fundStatuses.push(status));
          }) || [];
      }
      return fundStatuses;
    },
    formatDisplayName(data) {
      const fundSeries = get(data, 'fundSeries');
      let { displayName } = data;
      if (fundSeries && this.isOneClientView) {
        displayName = fundSeries.seriesName;
      }
      return displayName;
    },
    formatCategories(categories = []) {
      const list = (categories
          && Array.isArray(categories)
          && categories.map((item) => ({ name: get(item, 'category.name', '') })))
        || [];

      return this.formatToWeightedList(list, () => true);
    },
    formatStatus(approvalStatusArray, fund) {
      let status = get(fund, 'fundStatus.fundStatus');
      if (Array.isArray(approvalStatusArray) && approvalStatusArray.length > 0) {
        const approvalStatus = approvalStatusArray[0];
        status = {
          id: get(approvalStatus, 'id', 0),
          name: get(approvalStatus, 'name', ''),
        };
      }
      return status;
    },
    formatApprovalStatus(rowData, currentData, pendingData, disableNone) {
      // If has pendingStatus override production Status
      let data = currentData;
      if (this.isTargetSeries(rowData) && this.isOneClientView) {
        // In this case, we already have the pending statuses prioritized in the currentData array
        data = merge(currentData || [], pendingData || []);
      } else if (pendingData && Array.isArray(pendingData) && pendingData.length > 0) {
        data = pendingData;
      }

      const list = (Array.isArray(data)
          && data.map((item) => ({
            id: get(item, 'fundStatus.id', 0),
            name: get(item, 'fundStatus.name', ''),
          })))
        || [];

      // If the value returned here is an empty array this row won't be shown
      return this.formatToWeightedList(list, (el) => el.id !== 4 || disableNone === false);
    },
    formatActions(currentData, pendingData) {
      // If has pendingStatus override production Status
      const data = (pendingData && pendingData.length > 0 ? pendingData : currentData) || [];

      // Get all statusses for Approve (None or Removed)
      const forApprove = filter(
        data,
        (o) => o.fundStatus && (o.fundStatus.name === 'Removed' || o.fundStatus.name === 'None'),
      );

      // If statusses are for Approve else Change Status
      let action = '';
      if (forApprove.length === data.length) {
        action = 'approve';
      } else {
        action = 'change-status';
      }

      // If this action is not allowed assign empty
      if (!this.localPolicyOptions.actions[action]) {
        action = 'empty';
      }
      return action;
    },
    formatPreferred(rawData) {
      const data = { ...rawData };
      const canBeMarkAsPreferred = data
        && data.approvalStatus
        && data.approvalStatus.some((item) => item.name === 'Approved' || item.name === 'OnWatch');
      const preferredIcon = canBeMarkAsPreferred && !data.preferred
        ? 'star-rating-hypo'
        : this.actionsSchema.preferred.icon;
      return {
        canBeMarkAsPreferred,
        preferredIcon,
      };
    },
    formatToWeightedList(list = [], include, property = 'name') {
      // Group by ocurrence
      const weightedList = [];
      list.forEach((element) => {
        if (include(element)) {
          const index = findIndex(weightedList, [property, element[property]]);
          if (index === -1) {
            weightedList.push({
              [property]: element[property],
              id: element.id,
              value: 1,
            });
          } else {
            weightedList[index].value += 1;
            weightedList[index].id = element.id;
          }
        }
      });

      // Order by mayor ocurrence
      weightedList.sort((a, b) => {
        if ((a.value > b.value) || (a.value === b.value && a[property].toLowerCase() < b[property].toLowerCase())) {
          return -1;
        }
        if ((a.value < b.value) || (a.value === b.value && a[property].toLowerCase() > b[property].toLowerCase())) {
          return 1;
        }
        return 0;
      });

      return weightedList;
    },
    formatActionChoices(productRow, row, subRow) {
      const product = this.products[productRow];
      const rows = product.menus[product.selectedTab].fundsGroupedBySeries;
      const rowData = rows[row];

      let options = [
        {
          id: `change-status-${productRow}-${row}-${subRow || 'x'}`,
          disabled: false,
          text: this.actionsSchema['change-status'].tooltipMessage,
          data: {
            actionId: 'change-status',
            productRow,
            row,
            subRow,
            rowData,
          },
        },
      ];
      if (rowData?.__isTargetSeries) {
        options = [
          {
            id: `change-status-${productRow}-${row}-${subRow || 'x'}`,
            disabled: false,
            text: this.actionsSchema['change-status'].tooltipMessage,
            data: {
              actionId: 'change-status',
              productRow,
              row,
              subRow,
              rowData,
            },
          },
          {
            id: `manage-series-${productRow}-${row}-${subRow || 'x'}`,
            disabled: false,
            text: this.actionsSchema['manage-series'].tooltipMessage,
            data: {
              actionId: 'manage-series',
              productRow,
              row,
              subRow,
              rowData,
            },
          },
        ];
      }
      return options;
    },
    mustShowAction(productRow, content, row, subRow) {
      const product = this.products[productRow];
      const rows = product.menus[product.selectedTab].fundsGroupedBySeries;
      let data = rows[row];
      if (undefined !== subRow) {
        data = get(rows[row], `subs[${subRow}]`, {});
      }
      return (
        (content === 'change-status' || content === 'approve')
        // In the one client view we only show the gear icon with the fund
        //  setting menu that already includes the "Change Status" option
        && !(content === 'change-status' && this.isOneClientView)
        // In the one client view there shouldn't be displayed the approve icon at
        //  target series level, only at fund series level
        && !(content === 'approve' && data?.__isTargetSeries && this.isOneClientView)
      );
    },
    mustShowActionMenu(productRow, content, row, subRow) {
      const product = this.products[productRow];
      const rows = product.menus[product.selectedTab].fundsGroupedBySeries;
      let data = rows[row];
      if (undefined !== subRow) {
        data = get(rows[row], `subs[${subRow}]`, {});
      }
      return content === 'change-status' && !(content === 'change-status' && data?.__isFundSeries);
    },
    mustShowPreferred(productRow, key, row, subRow) {
      const product = this.products[productRow];
      const rows = product.menus[product.selectedTab].fundsGroupedBySeries;
      let data = rows[row];
      if (undefined !== subRow) {
        data = get(rows[row], `subs[${subRow}]`, {});
      }
      return (
        (!(key === 'preferred' && data?.__isFundSeries) || !this.isOneClientView)
        && data.canBeMarkAsPreferred
      );
    },
    getTooltipMessage(content) {
      if (this.isOneClientView && content === 'change-status') {
        return 'Settings';
      }
      return this.actionsSchema[content].tooltipMessage;
    },
    toggleFundSeries(productId, menuId, fundId) {
      this.products = this.products.map((product) => {
        const modifProduct = cloneDeep(product);
        if (modifProduct.productId === productId) {
          modifProduct.menus = modifProduct.menus.map((menuItem) => {
            const modifMenu = cloneDeep(menuItem);
            if (modifMenu.menuId === menuId) {
              modifMenu.fundsGroupedBySeries = modifMenu.fundsGroupedBySeries.map((item) => {
                if (item.id === fundId) {
                  /* eslint-disable no-param-reassign */
                  item.__hidden = !item.__hidden;
                  if (item.subs) {
                    /* eslint-disable no-param-reassign */
                    item.subs = item.subs.map((fund) => ({
                      ...fund,
                      __hidden: !fund.__hidden,
                    }));
                  }
                }
                return item;
              });
            }
            return modifMenu;
          });
        }
        return modifProduct;
      });
    },
  },
});
